/* import __COLOCATED_TEMPLATE__ from './event-impulses.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class EventImpulsesComponent extends Component 
{
	@service store;
	
	@action
	showAddRecordInterface(impulse)
	{
		impulse.set('showAddRecordInterface',!impulse.showAddRecordInterface);
	}
	
	@action
	async createStartRecord(impulse,browserEvent)
	{
		browserEvent.preventDefault();
		
		const  sTR = this.store.createRecord('StartTimingRecord',
		{
			participatesInAutoAssociation: false,
		});
		sTR.EventId = impulse.EventId;
		sTR.startImpulseId = impulse;
		
		try
		{
			await sTR.save();
		}
		catch (error)
		{
			alert(error);
		}
	}
	
	@action
	async createFinishRecord(impulse,browserEvent)
	{
		browserEvent.preventDefault();
		
		const fTR = this.store.createRecord('FinishTimingRecord',
		{
			participatesInAutoAssociation: false,
			hasDupFinish: true,
		});
		fTR.EventId = impulse.EventId;
		fTR.finishImpulseId = impulse;
		
		try
		{
			await fTR.save();
		}
		catch (error)
		{
			alert(error);
		}
	}
	
	@action
	async createPlungerRecord(impulse,browserEvent)
	{
		browserEvent.preventDefault();
		
		const fTR = this.store.createRecord('FinishTimingRecord',
		{
			participatesInAutoAssociation: false,
		});
		fTR.EventId = impulse.EventId;
		fTR.finishPlungerImpulseId = impulse;
		
		try
		{
			await fTR.save();
		}
		catch (error)
		{
			alert(error);
		}
	}
}